import {
  Component, EventEmitter, Input, Output, inject,
} from '@angular/core';

import { fillSkeletonData } from 'src/app/@shared/app-helper';

import { ProtocolModel } from 'src/app/protocol/@shared/protocol.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  // use onPush approach when performance is poor
  // changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'protocol-preview',
  styleUrls: ['./protocol-preview.component.scss'],
  templateUrl: './protocol-preview.component.html',
})
export class ProtocolPreviewComponent {
  @Output() public openDetail: EventEmitter<ProtocolModel> = new EventEmitter<ProtocolModel>();

  public previewText: string = fillSkeletonData('placeholder');

  private translate = inject(TranslateService);
  private _item: Partial<ProtocolModel> = {};

  @Input()
  public get item(): ProtocolModel {
    return this._item as ProtocolModel;
  }

  public set item(item: ProtocolModel | null) {
    // item is initially null (skeleton)
    if (!item) {
      return;
    }

    this._item = item as Partial<ProtocolModel>;
    this.setPreviewText();
  }

  private setPreviewText(): void {
    this.previewText = this.translate.instant('VIEW.PROTOCOL_PREVIEW.DESCRIPTION', {
      editorName: this.item.editorName,
      timestamp: new Date(this.item.createdAt).toLocaleString(),
    });
  }
}
